var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "955.468px",
    height: "1080px",
    viewBox: "0 0 955.468 1080",
    enableBackground: "new 0 0 955.468 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-individual-property-type-overview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M1879.503,628.336l65.382-66.024l-99.141-99.143 c-17.305-18.23-46.11-18.986-64.342-1.681c-0.576,0.544-1.137,1.104-1.684,1.681l-66.236-66.238l274.137-273.496 c104.964,50.208,230.755,5.821,280.965-99.142c50.208-104.965,5.82-230.757-99.143-280.966 c-104.964-50.208-230.756-5.821-280.965,99.143c-27.5,57.488-27.5,124.334,0,181.823l-520.498,521.565 c-29.814,24.687-33.973,68.862-9.289,98.678c24.685,29.813,68.861,33.973,98.678,9.286c3.224-2.667,6.201-5.62,8.899-8.819 l82.476-82.691l66.238,66.024c-18.291,17.58-18.866,46.662-1.283,64.954c0.419,0.435,0.847,0.862,1.283,1.283l99.143,99.142 l66.237-65.809l-66.237-66.025l99.143-99.142L1879.503,628.336z M2127.359-115.449c27.36,27.378,27.348,71.752-0.03,99.114 c-27.377,27.36-71.75,27.348-99.112-0.029c-27.35-27.366-27.35-71.718,0-99.085c27.193-27.376,71.433-27.525,98.81-0.331 C2127.139-115.67,2127.25-115.56,2127.359-115.449z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    points: "3138.04,864.686 3138.04,1055.815  2450.286,1055.815 2335.727,960.256 2450.286,864.686 2679.604,864.686 2679.604,750.125 2755.977,750.125 2755.977,864.686  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    points: "3176.227,616.379 3061.667,711.939  2373.913,711.939 2373.913,520.809 2679.604,520.809 2679.604,368.062 2755.977,368.062 2755.977,520.809 3061.667,520.809  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2679.602,
    y: 1094.003,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    width: 76.374,
    height: 343.876
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 50,
    strokeMiterlimit: 10,
    d: "M776.189,336.646 c0.36-168.304-132.972-305.038-297.805-305.405c-164.833-0.368-298.748,135.771-299.108,304.074 c-0.115,53.979,13.814,107.021,40.362,153.7l0,0l258.094,533.378l258.595-533.378l0,0 C762.644,442.745,776.403,390.15,776.189,336.646z M477.899,489.015c-82.417,0-149.228-68.219-149.228-152.369 c0-84.153,66.811-152.371,149.228-152.371c82.416,0,149.23,68.218,149.23,152.371c0.091,84.057-66.57,152.274-148.895,152.369 C478.124,489.015,478.011,489.015,477.899,489.015z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentIcon);
export default __webpack_public_path__ + "static/media/development-icon.3f2483c7b2596553094718e9a3cc966e.svg";
export { ForwardRef as ReactComponent };